import * as React from 'react';
import _HighchartsReact from 'highcharts-react-official';
import type { HighchartsReactRefObject, HighchartsReactProps } from 'highcharts-react-official';

// CJS/ESM interop shim for Vite 5+
const HighchartsReact: React.ForwardRefExoticComponent<
  React.PropsWithoutRef<HighchartsReactProps> & React.RefAttributes<HighchartsReactRefObject>
> = (_HighchartsReact as any).default ?? _HighchartsReact;

export default HighchartsReact;
